module.exports = __webpack_public_path__ + "img/breidablik-logo-icon.652abb60.png";